export default "__VITE_ASSET__CAAASbIT__"